import { render, staticRenderFns } from "./settingUpOfShippingOnlineCounter.vue?vue&type=template&id=49f8915e&"
import script from "./settingUpOfShippingOnlineCounter.vue?vue&type=script&lang=js&"
export * from "./settingUpOfShippingOnlineCounter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49f8915e')) {
      api.createRecord('49f8915e', component.options)
    } else {
      api.reload('49f8915e', component.options)
    }
    module.hot.accept("./settingUpOfShippingOnlineCounter.vue?vue&type=template&id=49f8915e&", function () {
      api.rerender('49f8915e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SystemMaintenance/components/basicConfig/settingUpOfShippingOnlineCounter.vue"
export default component.exports